import { render, staticRenderFns } from "./9.vue?vue&type=template&id=57a0a35e&scoped=true&"
import script from "./9.vue?vue&type=script&lang=js&"
export * from "./9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a0a35e",
  null
  
)

export default component.exports